export class POAcsMessage {
  static type = 'AcsMessage';

  id: number;
  acsRefId: number;
  acsId: string;
  dateTime: string;
  initObjName: string;
  holderName: string;
  holderAcsId: string;
  passNumber: string;
  eventType: string;
  eventName: string;
  initObjAcsId: string;
  holderId: number;

  constructor() {
    this.id = 0;
    this.acsId = '';
    this.dateTime = '';
    this.initObjName = '';
    this.holderName = '';
    this.passNumber = '';
    this.eventType = '';
  }
}
